/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";

import { getFileVersions, getResourcesUnderWhichFilesShared } from "@Actions/fileUpload";
import { useParams } from "react-router-dom";
import CreateTransmittal from "@Features/transmittals/pages/Transmitals/CreateTransmittal/CreateTransmittal";
import Text from "@CubeComponents/html/Text/Text";
import { convertDate } from "@Services/luxonHelper";
import type {
  FileResourcesUnderWhichFilesSharedRequest,
  FileVersionsRequest,
  SourceFileVersionData,
} from "@Types/fileOperations";
import type { SelectedFileItem } from "@Reducers/refreshFileManager";
import type { SharedResourceTransmittalItem } from "@ServerTypes/fileOperations/fileOperations.schemas";
import { RootState } from "@Reducers/index";

export interface SharingContentProps {
  resourceId: string;
  resourceType: string;
  fileVersionId?: string;
  transmittalVersionId?: string;
  workspaceId?: string;
}

interface SharingDataItem {
  transmittalNo?: number;
  fromUser?: string;
  fileVersionNumber?: number;
  toSpace: (string | undefined)[];
  fileStatusName: string;
  createdDate?: number;
  fromSpace?: string;
  isResourceForwarded: boolean;
}

type SharedTransmittalData = SharedResourceTransmittalItem | SharedResourceTransmittalItem[] | null;

function SharingContent(props: SharingContentProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filesSharedUnderResources = useSelector(
    (state: RootState): Record<string, SharedTransmittalData> => state.filesSharedUnderResources,
  );
  const fileVersionsState = useSelector((state: RootState) => state.fileVersions);
  const projectData = useSelector((state: RootState) => state.projectData);
  const selectedFiles = useSelector((state: RootState) => state.selectedFiles);
  const fileId = props.resourceId as string;
  const { resourceType, transmittalVersionId } = props;
  const params = useParams();
  const [sharingData, setSharingData] = useState<SharingDataItem[]>([]);
  const [fileVersions, setFileVersions] = useState<SourceFileVersionData[] | undefined>([]);
  const [openCreateTransmittalModal, setOpenCreateTransmittalModal] = useState(false);
  const [fileDetailsForTransmittal, setFileDetailsforTransmittal] = useState<SelectedFileItem[]>([]);

  useEffect(() => {
    dispatch(getFileVersions({ resourceType, fileId } as FileVersionsRequest));
    const payload: FileResourcesUnderWhichFilesSharedRequest = {
      resourceType,
      fileId,
    };
    dispatch(getResourcesUnderWhichFilesShared(payload));
  }, [fileId, resourceType, transmittalVersionId]);

  useEffect(() => {
    let fileVersions: SourceFileVersionData[] | undefined = [];

    if (fileVersionsState) {
      if (["RESOURCE_TYPE_FILE", "RESOURCE_TYPE_MERGED_FILE"].includes(resourceType)) {
        fileVersions = fileVersionsState[fileId];
      } else if (resourceType == "RESOURCE_TYPE_TASKS") {
        fileVersions = fileVersionsState[fileId];
      } else if (resourceType == "RESOURCE_TYPE_ISSUE") {
        // fileVersions = props.selectedFile;
        // fileId = props.selectedFile;
      }
    }
    setFileVersions(fileVersions);
  }, [fileVersionsState, fileId, resourceType]);

  const setSpaceSharingData = () => {
    let dataToMap: Record<string, SharedTransmittalData> | SharedTransmittalData[] | SharedResourceTransmittalItem[][] =
      filesSharedUnderResources;

    if (!Array.isArray(filesSharedUnderResources)) {
      if (filesSharedUnderResources.data && Array.isArray(filesSharedUnderResources.data)) {
        dataToMap = filesSharedUnderResources.data;
      } else {
        dataToMap = Object.values(filesSharedUnderResources);
      }
    }

    if (!Array.isArray(dataToMap[0])) {
      dataToMap = [Array.isArray(dataToMap) ? dataToMap : [dataToMap]] as SharedResourceTransmittalItem[][];
    }
    const sharingData = (dataToMap[0] as SharedResourceTransmittalItem[]).map(
      (item: SharedResourceTransmittalItem) => ({
        transmittalNo: item.indexAtProjectLevel,
        fromUser: item.createdBy?.fullName,
        fileVersionNumber: item.fileVersionNumber,
        toSpace: item.toSpaceIds?.map((space) => space.spaceName) ?? [],
        fileStatusName: "Active",
        createdDate: item.createdDate,
        fromSpace: item.fromSpace?.spaceName,
        isResourceForwarded: false,
      }),
    );
    sharingData.sort((a: SharingDataItem, b: SharingDataItem) => Number(b.createdDate) - Number(a.createdDate));
    setSharingData(sharingData);
  };

  useEffect(() => {
    if (filesSharedUnderResources[fileId]) {
      const transmittals = Object.keys(filesSharedUnderResources[fileId]);
      if (transmittals.length && fileVersions) {
        setSpaceSharingData();
      }
    }
  }, [filesSharedUnderResources, fileVersions]);

  const refreshSharingData = () => {
    dispatch(getFileVersions({ resourceType, fileId } as FileVersionsRequest));
    const payload: FileResourcesUnderWhichFilesSharedRequest = {
      resourceType,
      fileId,
    };
    dispatch(getResourcesUnderWhichFilesShared(payload));
  };

  const handleFileShareButtonClick = () => {
    setFileDetailsforTransmittal(selectedFiles);
    setOpenCreateTransmittalModal(true);
  };

  const messageTemplate = (data: SharingDataItem, type: string, show = true) => (
    <div>
      {`${data.fromUser} ${type}`}
      {show && <span style={{ fontWeight: "bold" }}>{` V${data.fileVersionNumber}`}</span>}
      {" in "}
      <span style={{ fontWeight: "bold" }}>{`TS-${data.transmittalNo}`}</span>
      {` from ${data.fromSpace} to ${data.toSpace.join(", ")}`}
    </div>
  );

  return (
    <>
      <div data-testid="transmitBtnComp">
        <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={handleFileShareButtonClick}>
          <Text>{t("Transmit")}</Text>
        </ButtonComponent>
      </div>
      <div className="flex flex-col pt-6 gap-5 pb-6">
        {sharingData.map((data: SharingDataItem) => (
          <div className="flex flex-wrap justify-between" key={`TS${data.transmittalNo}`}>
            {data.isResourceForwarded == false && messageTemplate(data, "shared")}

            {data.isResourceForwarded == true && messageTemplate(data, "forwarded")}
            <div className="grid justify-items-end">{convertDate(Number(data.createdDate), "dateForText")}</div>
          </div>
        ))}
      </div>
      {createPortal(
        <CreateTransmittal
          isOpen={openCreateTransmittalModal}
          onClose={() => {
            setOpenCreateTransmittalModal(false);
            refreshSharingData();
          }}
          projectId={projectData.id as string}
          selectedSpaceId={params.workspaceId ?? props.workspaceId}
          selectedReferences={fileDetailsForTransmittal}
        />,
        document.body,
      )}
    </>
  );
}

export default SharingContent;
